import { KnownInternalNames } from "@layerswap/utils";
class NetworkSettings {
    static get KnownSettings() {
        if (!NetworkSettings._knownSettings) {
            NetworkSettings._knownSettings = {};
            NetworkSettings.Initialize();
        }
        return NetworkSettings._knownSettings;
    }
    static Initialize() {
        if (NetworkSettings._isInitialized) {
            return;
        }
        NetworkSettings._isInitialized = true;
        NetworkSettings.KnownSettings[KnownInternalNames.Networks.EthereumSepolia] = {
            ChainOrder: 1
        };
        NetworkSettings.KnownSettings[KnownInternalNames.Networks.TempoTestnet] = {
            FeeParsingDecimalPlaces: 18,
        };
        NetworkSettings.KnownSettings[KnownInternalNames.Networks.TempoMainnet] = {
            FeeParsingDecimalPlaces: 18,
        };
    }
}
NetworkSettings._isInitialized = false;
export default NetworkSettings;
